import React from "react";

export default function CardsSkeleton() {
  const Card = () => (
    <div className="rounded-2xl border border-light-gray-alt dark:border-deep-purple/50 bg-white dark:bg-soft-black overflow-hidden animate-pulse">
      <div className="aspect-[16/9] bg-light-gray dark:bg-deep-purple/30" />
      <div className="p-6 space-y-4">
        <div className="h-6 bg-light-gray dark:bg-deep-purple/30 rounded w-2/3" />
        <div className="h-4 bg-light-gray dark:bg-deep-purple/30 rounded w-1/3" />
        <div className="h-4 bg-light-gray dark:bg-deep-purple/30 rounded w-4/5" />
        <div className="h-10 bg-light-gray dark:bg-deep-purple/30 rounded" />
      </div>
    </div>
  );
  return (
    <div className="mt-8 grid sm:grid-cols-2 xl:grid-cols-3 gap-8">
      <Card />
      <Card />
      <Card />
    </div>
  );
}